export const pensionAssets = {
  HEB: {
    header: "ייבוא נכסים פנסיונים",
    description:
      "אנחנו נייבא עבורך מידע עבור כלל הנכסים הפנסיוניים שעל שמך מהמסלקה הפנסיונית ונעדכן אותם מדי חודש למשך שנה,",
    feeParagraph:
      'הייבוא הינו בעלות חד-פעמית של 35 ש"ח לשנה (חידוש כרוך בתשלום נוסף).',
    description2: {
      part1: "הייבוא הינו",
      bold: "",
      part2: "בעלות חד-פעמית של 47 שקלים",
    },
    description3: {
      part1:
        "על מנת לבצע את הייבוא, נא למלא את הפרטים הבאים:",
      part2: "",
    },
    inputLabels: {
      address: "כתובת",
      city: "עיר",
      street: "רחוב",
      postalCode: "מיקוד",
      houseNumber: "מס' בית",
    },
    multipleMaslulNote: 
    "המידע המתקבל מגיע ישירות מהמסלקה הפנסיונית באמצעות רישיון 027225424 ניתן לצפות בתנאי השימוש שלנו באתר. *לא ניתן לקבל החזר על חלק מהתקופה.",
    clarification: 
    "על מנת לבצע את הייבוא, נא למלא את הפרטים הבאים:",
    confirmation1: "אני מאשר/ת מילוי ושליחה בשמי של טופס",
    linkA: "'נספח א'",
    confirmationA: "כדי שתוכלו לייבא עבורי את הנתונים.",
    moveToPayment: "מעבר לתשלום",
    moveToMasleka: "מעבר למסלקה",

    incompleteAddress:
      "יש למלא את הכתובת המלאה בכדי שנוכל לייבא בשמך את הנכסים שלך.",
    incompleteSignature: "איך נוכל לייבא בשמך ללא חתימתך?",
    missingConfirmationA:
      "אנחנו חייבים אישור של סעיף זה בכדי שנוכל לייבא בשמך את הנכסים שלך.",
    failedPayment: {
      header: "התשלום נכשל",
      list: "נסו אחת מהפעולות הבאות:",
      list1: "1. לנסות לשלם בכרטיס אחר.",
      list2: "2. לבדוק שכל פרטי הכרטיס רשומים בצורה נכונה",
      tryAgain: "נסה שנית",
    },
    paymentNotVerified: {
      header: "האימות נכשל",
      content:
        "התשלום צריך להתבצע עם כרטיס אשראי על שמך בלבד לצורכי אימות. יש לוודא שתעודת הזהות שהוזנה במילוי הפרטים תואמת לתעודת זהות שהזנת בפרטי האשראי.",
      tryAgain: "נסה שנית",
    },
    chargeNotCancel: {
      header: "הבקשה לייבוא מהמסלקה נכשלה",
      content:
        "כדי שהבקשה תישלח בהצלחה התשלום צריך להתבצע עם כרטיס אשראי על שימך בלבד לצורכי אימות, לצערנו לא הצלחנו לבטל את החיוב. יש לפנות לשירות הלקוחות במייל  office@moneytor.co.il לקבלת החזר.",
    },
    successfulPayment: {
      header: "תודה! הפרטים נשלחו בהצלחה.",
      header2: {
        part1: "פרטי התשלום התקבלו בהצלחה",
        bold: "החיוב יתבצע רק בסיום של שליחת הפרטים באתר המסלקה",
        part2: "למעבר לאתר המסלקה למילוי פרטים הקליקו כאן:",
      },
      done: "מעבר לאתר המסלקה",
    },
    successfulMasleka: {
      header: "המסלקה שלך התקבלה בהצלחה",
      header2: {
        part1: "המידע שלך התקבל בהצלחה! הפרטים של הקופות הפנסיוניות שלך צפויים להגיע לאתר תוך 72-3 שעות",
        bold: "החיוב יתבצע כעת",
        part2: "לחזרה לעמוד הנכסים הקליקו על אישור",
      },
      done: "אישור",
    },
    errorMasleka: {
      header: "הייתה בעיה בתהליך ייבוא הנתונים הפנסיוניים",
      header2: {
        part1: "קיבלנו קוד שגיאה בתהליך הייבוא שלך",
        bold: "החיוב יתבטל כעת",
        part2: "ניתן להתחיל את התהליך מחדש על מנת להשלים את הייבוא",
      },
      done: "אישור",
    },
    canceledMasleka: {
      header: "תהליך ייבוא הנתונים הפנסיוניים התבטל באמצע",
      header2: {
        part1: "תהליך ייבוא הנתונים הפנסיוניים לא הושלם כהלכה",
        bold: "החיוב יתבטל כעת",
        part2: "ניתן להתחיל את התהליך מחדש על מנת להשלים את הייבוא",
      },
      done: "אישור",
    },

    plannerPaymentSuccess: "התשלום התבצע בהצלחה!",
    plannerPaymentDescription: "התשלום בוצע בהצלחה ומכסת המסלקות תתווסף לחשבונך.",
    plannerPaymentToggleInfo1: "ניתן להעניק מסלקות חינם ללקוחות באמצעות המתג",
    plannerPaymentToggleLabel: "תשלום עבור מסלקה",
    plannerPaymentToggleInfo2: "במסך",
    plannerPaymentManageScreen: "ניהול לקוחות ותקציב",
    close: "סגור",
    freeOfCharge: "ללא עלות",
    oneTimeFeeOf: "בעלות חד-פעמית של",
    continueWithoutPayment: "המשך ללא תשלום",
    cannotPayNow: "לא ניתן לשלם כרגע. פנו למתכנן להסדרת התשלום.",
    noEntranceNeeded: "(אין צורך להזין כניסה)",
    maslekaDate: {
      header: "אין סיבה לייבא מחדש",
      description1:
        "שילמתם על עדכון שנתי מתחדש מדי חודש ועדיין לא עברה שנה מאז פעולת הייבוא הקודמת שלכם, לכן אין טעם לחדש את הייבוא עד שיעברו 12 חודשים. הנתונים הפנסיונים ימשיכו להתעדכן לכם באופן חודשי בצורה אוטומטית.",
      description2: "בתאריך",
      description3: "הנתונים יפסיקו להתעדכן וניתן יהיה לחדש את הייבוא",
      spouseHeader: "רוצים לייבא נתונים עבור בן/בת הזוג?",
      spouseDescription:
        "בן/בת הזוג צריכים ליצור חשבון מאניטור משלהם. לאחר מכן, הזמינו אותם לחשבון המשפחתי שלכם. ברגע שיאשרו את ההזמנה ויבצעו ייבוא מסלקה מהחשבון שלהם, תוכלו לראות את הנתונים של שניכם בשני החשבונות.",
      spouseLinkText: "מעבר לחשבון המשפחתי",
      done: "הבנתי, תודה",
    },
  },
  ENG: {
    header: "Pension asset import",
    description:
      "We will import data for all your pension assets from the Pension Clearinghouse and update them monthly for a year!",
    feeParagraph:
      "The import is a one-time fee of ₪35 for one year (renewal requires an additional payment).",
    description2: {
      part1: "The import is",
      bold: "",
      part2: "a one-time fee of 47 ILS",
    },
    description3: {
      part1: "To perform the import, please fill in the following details:",
      part2: "",
    },
    inputLabels: {
      address: "Address",
      city: "City",
      street: "Street",
      postalCode: "Postal code",
      houseNumber: "House number",
    },
    multipleMaslulNote: "The data is received directly from the Pension Clearinghouse via license 027225424. See our terms of service on the website. *Partial period refunds are not available.",
    clarification: "To perform the import, please fill in the following details:",
    confirmation1: "I authorize filling and submitting on my behalf the form",
    linkA: "'Appendix A'",
    confirmationA: "so that you can import my data.",
    moveToPayment: "Proceed to payment",
    moveToMasleka: "Proceed to Masleka",
    incompleteAddress: "Please enter your full address so we can import your assets.",
    incompleteSignature: "How can we import on your behalf without your signature?",
    missingConfirmationA: "We need your approval of this clause to import your assets.",
    failedPayment: {
      header: "Payment failed",
      list: "Try one of the following:",
      list1: "1. Try paying with a different card.",
      list2: "2. Verify that all card details are correct",
      tryAgain: "Try again",
    },
    paymentNotVerified: {
      header: "Verification failed",
      content: "Payment must be made with a credit card in your name for verification purposes. Make sure the ID number entered matches the one on your credit card.",
      tryAgain: "Try again",
    },
    chargeNotCancel: {
      header: "Clearinghouse import request failed",
      content: "Unfortunately, we were unable to cancel the charge. Please contact support at office@moneytor.co.il for a refund.",
    },
    successfulPayment: {
      header: "Thank you! Details submitted successfully.",
      header2: {
        part1: "Payment details received successfully",
        bold: "The charge will only be made after completing the form on the Clearinghouse website",
        part2: "Click here to proceed to the Clearinghouse website:",
      },
      done: "Go to Clearinghouse website",
    },
    successfulMasleka: {
      header: "Your Masleka was received successfully",
      header2: {
        part1: "Your data was received successfully! Your pension fund details are expected to arrive within 3-72 hours",
        bold: "The charge will be made now",
        part2: "Click confirm to return to the assets page",
      },
      done: "Confirm",
    },
    errorMasleka: {
      header: "There was a problem with the pension data import process",
      header2: {
        part1: "We received an error code during your import process",
        bold: "The charge will be cancelled now",
        part2: "You can restart the process to complete the import",
      },
      done: "Confirm",
    },
    canceledMasleka: {
      header: "Pension data import was cancelled mid-process",
      header2: {
        part1: "The pension data import process was not completed successfully",
        bold: "The charge will be cancelled now",
        part2: "You can restart the process to complete the import",
      },
      done: "Confirm",
    },
    plannerPaymentSuccess: "Payment successful!",
    plannerPaymentDescription: "Payment was successful and the Masleka quota will be added to your account.",
    plannerPaymentToggleInfo1: "You can grant free Masleka imports to clients using the",
    plannerPaymentToggleLabel: "Pay for Masleka",
    plannerPaymentToggleInfo2: "toggle on the",
    plannerPaymentManageScreen: "Client & budget management",
    close: "Close",
    freeOfCharge: "free of charge",
    oneTimeFeeOf: "a one-time fee of",
    continueWithoutPayment: "Continue without payment",
    cannotPayNow: "Cannot pay at this time. Contact your planner to arrange payment.",
    noEntranceNeeded: "(No need to enter entrance)",
    maslekaDate: {
      header: "No need to re-import",
      description1: "You paid for an annual subscription that renews monthly and a year hasn't passed since your last import, so there's no point in renewing until 12 months have passed. Your pension data will continue to update automatically each month.",
      description2: "On",
      description3: "the data will stop updating and you'll be able to renew the import",
      spouseHeader: "Want to import data for your spouse?",
      spouseDescription:
        "Your spouse needs to create their own Moneytor account. Then, invite them to your family account. Once they accept the invitation and complete their Masleka import, you'll both be able to see each other's data in both accounts.",
      spouseLinkText: "Go to family account",
      done: "Got it, thanks",
    },
  },
  RUS: {
    header: "Импорт пенсионных активов",
    description:
      "Мы импортируем данные по всем вашим пенсионным активам из Пенсионной клиринговой палаты и будем обновлять их ежемесячно в течение года!",
    feeParagraph:
      "Импорт — разовый платёж 35 ₪ на год (продление требует дополнительной оплаты).",
    description2: {
      part1: "Импорт осуществляется",
      bold: "",
      part2: "за разовую плату в 47 шекелей",
    },
    description3: {
      part1: "Для выполнения импорта, пожалуйста, заполните следующие данные:",
      part2: "",
    },
    inputLabels: {
      address: "Адрес",
      city: "Город",
      street: "Улица",
      postalCode: "Почтовый индекс",
      houseNumber: "Номер дома",
    },
    multipleMaslulNote: "Данные поступают напрямую из Пенсионной клиринговой палаты по лицензии 027225424. Ознакомьтесь с нашими условиями использования на сайте. *Частичный возврат за неиспользованный период невозможен.",
    clarification: "Для выполнения импорта, пожалуйста, заполните следующие данные:",
    confirmation1: "Я разрешаю заполнение и отправку от моего имени формы",
    linkA: "«Приложение А»",
    confirmationA: "чтобы вы могли импортировать мои данные.",
    moveToPayment: "Перейти к оплате",
    moveToMasleka: "Перейти к Маслека",
    incompleteAddress: "Пожалуйста, введите полный адрес, чтобы мы могли импортировать ваши активы.",
    incompleteSignature: "Как мы сможем выполнить импорт от вашего имени без вашей подписи?",
    missingConfirmationA: "Нам необходимо ваше согласие с этим пунктом для импорта ваших активов.",
    failedPayment: {
      header: "Оплата не удалась",
      list: "Попробуйте одно из следующих действий:",
      list1: "1. Попробуйте оплатить другой картой.",
      list2: "2. Проверьте правильность всех данных карты",
      tryAgain: "Попробовать снова",
    },
    paymentNotVerified: {
      header: "Верификация не удалась",
      content: "Оплата должна быть произведена кредитной картой на ваше имя для целей верификации. Убедитесь, что введённый номер удостоверения совпадает с номером на кредитной карте.",
      tryAgain: "Попробовать снова",
    },
    chargeNotCancel: {
      header: "Запрос на импорт из клиринговой палаты не удался",
      content: "К сожалению, нам не удалось отменить списание. Пожалуйста, обратитесь в службу поддержки для возврата средств.",
    },
    successfulPayment: {
      header: "Спасибо! Данные успешно отправлены.",
      header2: {
        part1: "Платёжные данные успешно получены",
        bold: "Списание будет произведено только после заполнения формы на сайте клиринговой палаты",
        part2: "Нажмите здесь, чтобы перейти на сайт клиринговой палаты:",
      },
      done: "Перейти на сайт клиринговой палаты",
    },
    successfulMasleka: {
      header: "Ваша Маслека успешно получена",
      header2: {
        part1: "Ваши данные успешно получены! Данные о ваших пенсионных фондах поступят в течение 3-72 часов",
        bold: "Списание будет произведено сейчас",
        part2: "Нажмите «Подтвердить», чтобы вернуться на страницу активов",
      },
      done: "Подтвердить",
    },
    errorMasleka: {
      header: "Возникла проблема с процессом импорта пенсионных данных",
      header2: {
        part1: "Мы получили код ошибки в процессе вашего импорта",
        bold: "Списание будет отменено",
        part2: "Вы можете перезапустить процесс для завершения импорта",
      },
      done: "Подтвердить",
    },
    canceledMasleka: {
      header: "Импорт пенсионных данных был прерван",
      header2: {
        part1: "Процесс импорта пенсионных данных не был завершён успешно",
        bold: "Списание будет отменено",
        part2: "Вы можете перезапустить процесс для завершения импорта",
      },
      done: "Подтвердить",
    },
    plannerPaymentSuccess: "Оплата успешна!",
    plannerPaymentDescription: "Оплата прошла успешно, и квота Маслека будет добавлена на ваш счёт.",
    plannerPaymentToggleInfo1: "Вы можете предоставить бесплатный импорт Маслека клиентам с помощью переключателя",
    plannerPaymentToggleLabel: "Оплата за Маслека",
    plannerPaymentToggleInfo2: "на экране",
    plannerPaymentManageScreen: "Управление клиентами и бюджетом",
    close: "Закрыть",
    freeOfCharge: "бесплатно",
    oneTimeFeeOf: "разовая плата в размере",
    continueWithoutPayment: "Продолжить без оплаты",
    cannotPayNow: "Оплата сейчас невозможна. Обратитесь к вашему планировщику для организации оплаты.",
    noEntranceNeeded: "(Не нужно вводить вход)",
    maslekaDate: {
      header: "Нет необходимости в повторном импорте",
      description1: "Вы оплатили годовую подписку с ежемесячным обновлением, и год ещё не прошёл с момента последнего импорта, поэтому нет смысла обновлять до истечения 12 месяцев. Ваши пенсионные данные будут обновляться автоматически каждый месяц.",
      description2: "С",
      description3: "данные перестанут обновляться, и вы сможете возобновить импорт",
      spouseHeader: "Хотите импортировать данные для супруга/супруги?",
      spouseDescription:
        "Супруг/супруга должны создать собственный аккаунт Moneytor. Затем пригласите их в ваш семейный аккаунт. Как только они примут приглашение и выполнят импорт Маслека, вы оба сможете видеть данные друг друга в обоих аккаунтах.",
      spouseLinkText: "Перейти к семейному аккаунту",
      done: "Понятно, спасибо",
    },
  },
};
